import axiosInstance from 'services/axiosMiddleware';

// Updated function to accept category data
export async function editCourse(coursedata) {
  try {
    const response = await axiosInstance.post('course/editCourse', coursedata);
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
}
